import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchLivesByGames} from 'liveActions.js';

const withLives = (WrappedComponent) => {
    class WithLives extends Component {

        constructor(props) {
            super(props);
            this.livesInterval = null;
        }

        componentDidMount() {
            //  clear all intervals
            const {fetchLivesByGames} = this.props;
            fetchLivesByGames();
            this.livesInterval = setInterval(fetchLivesByGames, 8000);
        }

        componentWillUnmount() {
            if (this.livesInterval) {
                clearInterval(this.livesInterval);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    const mapDispatchToProps = (dispatch) => {
        return {
            fetchLivesByGames: bindActionCreators(fetchLivesByGames, dispatch),
            dispatch
        }
    };

    return connect(null, mapDispatchToProps)(WithLives);
};

export default withLives;
